module.exports = __webpack_public_path__ + "img/dotted.67d01cca.svg";